import * as React from "react";
import Button from "@material-ui/core/Button";
import ApplicationStatusMessageDeactivationConfirmationModal from "./ApplicationStatusMessageDeactivationConfirmationModal";

import { groupAuth } from "app/utils/authGroups";

const hasPermission = groupAuth.hasAccessGroup(["Ops/Admin"]);

type State = {
  showModal: boolean;
};

type Props = {
  applicationStatusMessage: any;
};

export default class ApplicationStatusMessageActivateContainer extends React.Component<
  Props,
  State
> {
  state = {
    showModal: false,
  };

  onCloseModal = () => {
    this.setState({ showModal: !this.state.showModal });
  };

  getButtonLabel = () => {
    if (hasPermission && !this.props.applicationStatusMessage.deactivated_at) {
      return "Deactivate";
    } else if (this.props.applicationStatusMessage.deactivated_at) {
      return "Deactivated";
    } else {
      return "Unauthorised";
    }
  };

  render() {
    return (
      <React.Fragment>
        <Button
          color="primary"
          variant="contained"
          onClick={() => {
            this.setState({ showModal: true });
          }}
          disabled={
            this.props.applicationStatusMessage.deactivated_at || !hasPermission
          }
        >
          {this.getButtonLabel()}
        </Button>
        {this.state.showModal && (
          <ApplicationStatusMessageDeactivationConfirmationModal
            applicationStatusMessage={this.props.applicationStatusMessage}
            onClose={this.onCloseModal}
          />
        )}
      </React.Fragment>
    );
  }
}
